/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Store selector [Plus]
window.onload = function() {
  var plusStoreSelectorDesktop = document.querySelector('[aria-controls="plus-store-selector"]');
  var plusStoreSelectorMobile = document.getElementById('plus-store-selector--mobile');
  var plusPopup = document.getElementById('plus-store-selector');
  var plusCloseIcon = document.querySelector('.plus-store-selector-popup__close span');
  var plusCloseButton = document.querySelector('#plus-store-selector .button');
  var selectorCookie = readCookie('plus-store-prompted');

  function createCookie(name, value, hours) {
    if (hours) {
      var date = new Date();
      date.setTime(date.getTime() + (hours * 3600 * 1000));
      var expires = "; expires=" + date.toUTCString();
    } else {
      var expires = "";
    }

    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Open popup
  function openPopup() {
    this.setAttribute('aria-expanded', 'true');
    plusPopup.setAttribute('aria-hidden', 'false');
  }

  // Close popup and create cookie so it doesn't always auto show
  function closePopup() {
    createCookie('plus-store-prompted', true, Plus.storeSelectorCookieExpiry);
    this.setAttribute('aria-expanded', 'false');
    plusPopup.setAttribute('aria-hidden', 'true');
  }

  if (plusPopup) {
    // Open popup on click
    plusStoreSelectorDesktop.addEventListener('click', openPopup);
    plusStoreSelectorMobile.addEventListener('click', openPopup);

    // Close popup on "X"
    plusCloseIcon.addEventListener('click', closePopup);

    // Close popup on button
    plusCloseButton.addEventListener('click', closePopup);

    // Auto show the popup if shop currency doesn't match cart current
    // and it hasn't already been shown in 72 hours
    if (Plus.storeSelectorTrigger && !selectorCookie) {
      if (window.innerWidth > 999) {
        plusStoreSelectorDesktop.click();
      } else {
        plusStoreSelectorMobile.click();
      }
    }
  }
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}